import { provideState } from '@ngrx/store';

import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import {
  TellentNavigationHttpContract,
  TellentNavigationViewID,
  TellentNavigationScope,
} from '@core/tellent-types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<TellentNavigationHttpContract>()('tellent-navigation', {
    customActions: adapter => {
      const reducerFunctions = getEntityCollectionActions(
        adapter,
        ({ id }: { id: TellentNavigationViewID }) => id,
      );

      return {
        fetchMainNav: (state, payload: { navScope: TellentNavigationScope[] }) =>
          reducerFunctions.fetchCollection(state, {
            scope: TellentNavigationViewID.Main,
            ...payload,
          }),
        fetchMainNavSuccess: (state, payload: { data: TellentNavigationHttpContract[] }) =>
          reducerFunctions.fetchCollectionSuccess(state, {
            scope: TellentNavigationViewID.Main,
            ...payload,
          }),
        fetchMainNavFailed: (state, payload) =>
          reducerFunctions.fetchCollectionFailed(state, {
            scope: TellentNavigationViewID.Main,
            ...payload,
          }),
        fetchSettingsNav: (state, payload: { navScope: TellentNavigationScope[] }) =>
          reducerFunctions.fetchCollection(state, {
            scope: TellentNavigationViewID.Settings,
            ...payload,
          }),
        fetchSettingsNavSuccess: (state, payload: { data: TellentNavigationHttpContract[] }) =>
          reducerFunctions.fetchCollectionSuccess(state, {
            scope: TellentNavigationViewID.Settings,
            ...payload,
          }),
        fetchSettingsNavFailed: (state, payload) =>
          reducerFunctions.fetchCollectionFailed(state, {
            scope: TellentNavigationViewID.Settings,
            ...payload,
          }),
      };
    },
  });

const provider = provideState(namespace, reducer);

const TellentNavigationActions = {
  fetchMainNav: actions.fetchMainNav,
  fetchMainNavSuccess: actions.fetchMainNavSuccess,
  fetchMainNavFailed: actions.fetchMainNavFailed,

  fetchSettingsNav: actions.fetchSettingsNav,
  fetchSettingsNavSuccess: actions.fetchSettingsNavSuccess,
  fetchSettingsNavFailed: actions.fetchSettingsNavFailed,
};

const TellentNavigationSelectors = {
  selectMainNav: selectors.byId(TellentNavigationViewID.Main),
  selectMainNavMeta: selectors.meta({ scope: TellentNavigationViewID.Main }),

  selectSettingsNav: selectors.byId(TellentNavigationViewID.Settings),
  selectSettingsNavMeta: selectors.meta({ scope: TellentNavigationViewID.Settings }),
};

export {
  TellentNavigationActions,
  TellentNavigationSelectors,
  provider as TellentNavigationStateProvider,
  namespace as TellentNavigationNamespace,
  reducer as TellentNavigationReducer,
};
